<template>
	<div>

    <div class="section-title">{{ $t('report.'+name+'.title') }}</div>

    <div class="p-grid">

      <div v-for="(guide,index) in structure" :key="name + '_' + index" :class="['p-pt-1 p-pb-1', 'p-col-12 p-sm-12',{'p-md-6 p-lg-6 p-xl-4' : guide.type!='absorptions'}, {'hidden': guide.hidden}]" >

        <SimpleText v-if="guide.mode==='simple' && guide.type==='text'" 
          :section="name" :guide="guide" :data="data" 
          @update:data="dataChanged"/>
        
        <SimpleNumber v-if="guide.mode==='simple' && guide.type==='number'" 
          :section="name" :guide="guide" :data="data" 
          @update:data="dataChanged" :extras="extras" />
        
        <SimpleSelect v-if="guide.mode==='simple' && guide.type==='select'" 
          :section="name" :guide="guide" :data="data" :domains="domains" :reportId="reportId"
          @update:data="dataChanged"/>
        
        <SimpleCheck v-if="guide.mode==='simple' && guide.type==='check'" 
          :section="name" :guide="guide" :data="data"
          @update:data="dataChanged"/>
        
        <SimpleRadio v-if="guide.mode==='simple' && guide.type==='radio'" 
          :section="name" :guide="guide" :data="data"
          @update:data="dataChanged"/>
        
        <ComplexColumn v-if="guide.mode==='complex' && guide.type==='column'" 
          :section="name" :guide="guide" :data="data" :domains="domains"
          @update:data="dataChanged" :extras="extras"/>
        
        <ComplexTimeslots v-if="guide.mode==='complex' && guide.type==='timeslots'" 
          :section="name" :guide="guide" :data="data"
          @update:data="dataChanged"/>
        
        <ComplexAbsorptions v-if="guide.mode==='complex' && guide.type==='absorptions'" 
          :section="name" :guide="guide" :data="data"
          @update:data="dataChanged"/>
        
        <ComplexDelta v-if="guide.mode==='complex' && guide.type==='delta'" 
          :section="name" :guide="guide" :data="data"
          @update:data="dataChanged"/>
        
        <StaticImage v-if="guide.mode==='static' && guide.type.startsWith('image_')" 
          :section="name" :guide="guide" :extras="extras"/>

        <StaticLink v-if="guide.mode==='static' && guide.type==='link'" 
          :section="name" :guide="guide" />

      </div>

    </div>

    <!-- <pre>{{ JSON.stringify(data,null,2) }}</pre> -->
		
  </div>

</template>

<script>
import ReportService from '../../service/ReportService';
import SimpleText from './simple/Text';
import SimpleNumber from './simple/Number';
import SimpleSelect from './simple/Select';
import SimpleCheck from './simple/Check';
import SimpleRadio from './simple/Radio';
import ComplexColumn from './complex/Column';
import ComplexTimeslots from './complex/Timeslots';
import ComplexAbsorptions from './complex/Absorptions';
import ComplexDelta from './complex/Delta';
import StaticImage from './static/Image';
import StaticLink from './static/Link';
import { mapGetters } from 'vuex';

export default {
  emits: ['update:data'],
  components: {
    SimpleText,
    SimpleNumber,
    SimpleSelect,
    SimpleCheck,
    SimpleRadio,
    ComplexColumn,
    ComplexTimeslots,
    ComplexAbsorptions,
    ComplexDelta,
    StaticImage,
    StaticLink,
  },
  props: {
      reportId: String,
      structure: Object,
      data: Object,
      name: String,
      domains: Object,
      extras: Object,
    },
  data() {
    return {
      tmpData: null,
      dialog: {
        error: false,
        blockingError: false,
        success: false
      }
    }
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      unit: 'userdata/unit',
      isCelsius: 'userdata/isCelsius',
    }),
  },
  created() {
    this.reportService = new ReportService();
  },
  mounted() {
  },
  watch: {
  },
  methods: {
    dataChanged(updatedData) {
      updatedData.section = this.name;
      this.$emit("update:data", updatedData);
    }
  }
}
</script>

<style scoped>

</style>